import axios from 'axios';
import type practiceAreaType from '@/types/PracticeAreaType';
import type { requestPosibilityCheck } from '@/types/RequestPosibilityCheck';
import type startResearchDataType from '@/types/StartResearchDataType';
import { socketPassword } from '@/main';
import type contactInformationType from '@/types/ContactInformationType';
import type {
  FullResponseResearchType,
  ResearchType,
} from '@/types/ResearchType';
import httpErrorHandler from '@/services/HttpErrorHandler';

const apiHost = import.meta.env.VITE_API_URL;
const practiceAreaApiHost =
  import.meta.env.VITE_PRACTICE_AREA_API_URL ||
  'https://it-grader-back.itd.comradeserver.com';

const httpClient = axios.create({
  baseURL: apiHost,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

const practiceAreaHttpClient = axios.create({
  baseURL: practiceAreaApiHost,
  headers: {
    'Content-Type': 'application/json',
  },
});

export type HubspotFormField = {
  name: string;
  value: any;
};

export type HubspotFormSubmitRequest = {
  formId: string;
  portalId?: string;
  brand?: string;
  // Общий id конверсии для дедупликации с серверным Conversions API.
  eventId?: string;
  fields: HubspotFormField[];
  context: {
    hutk?: string;
    pageUri: string;
  };
};

export const getAddressInfomation = async (place_id: string) => {
  return await httpClient
    .get('/api/objects/get-address-information?place_id=' + place_id)
    .catch(httpErrorHandler);
};

export const getPracticeAreas = async () => {
  return await httpClient
    .get<Array<practiceAreaType>>('/api/practice-areas/all')
    .catch(httpErrorHandler);
};

export type DetectPracticeAreaRequest = {
  businessName: string;
  website?: string;
  address?: string;
  forceRefresh?: boolean;
};

export type DetectPracticeAreaResponse = {
  practice_area: string;
  city?: string;
  state?: string;
};

export const detectPracticeArea = async (data: DetectPracticeAreaRequest) => {
  return await practiceAreaHttpClient
    .post<DetectPracticeAreaResponse>('/research/practice-area', data)
    .catch(httpErrorHandler);
};

export const fetchPosibilityCheck = async (data: requestPosibilityCheck) => {
  return await httpClient
    .post('/api/keywords/posibility-check', data)
    .catch(httpErrorHandler);
};

export const startResearches = async (data: startResearchDataType) => {
  return await httpClient
    .post<FullResponseResearchType>(`/api/researches`, data, {
      headers: {
        token: socketPassword,
      },
    })
    .catch(httpErrorHandler);
};

export const getResearch = async (
  _id: string,
  options?: { silent?: boolean },
) => {
  const request = httpClient.get<ResearchType>('/api/researches/' + _id);
  return options?.silent ? request : request.catch(httpErrorHandler);
};

export const saveContactInformation = async (
  research_id: string,
  data: contactInformationType,
) => {
  return await httpClient
    .put(`/api/researches/${research_id}`, data)
    .catch(httpErrorHandler);
};

// Submit HubSpot form via backend (backend should forward to HubSpot Forms API)
export const submitHubspotForm = async (data: HubspotFormSubmitRequest) => {
  return await httpClient
    .post('/api/hubspot/forms/submit', data)
    .catch(httpErrorHandler);
};
